import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const LanguageToggle = () => {
  const { language, setLanguage } = useLanguage();

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
  };

  return (
    <div className="flex  bg-white rounded-l-full rounded-r-full  mt-2">
      <button
        className={`${language === 'English' ? 'bg-[#c66a10]  text-white' : ' text-[#c66a10]'} rounded-full py-2 px-4 w-1/3`}
        onClick={() => handleLanguageChange('English')}
      >
        English
      </button>
      <button
        className={`${language === 'Gujarati' ? 'bg-[#c66a10] text-white' : 'text-[#c66a10]'} py-2 px-4 rounded-full w-1/3`}
        onClick={() => handleLanguageChange('Gujarati')}
      >
        ગુજરાતી
      </button>
      <button
        className={`${language === 'Hindi' ? 'bg-[#c66a10] text-white' : 'text-[#c66a10]'} py-2 px-4 rounded-full w-1/3`}
        onClick={() => handleLanguageChange('Hindi')}
      >
        हिन्दी
      </button>
    </div>
  );
};

export default LanguageToggle;
